export const CoreEvents = {
    READY: 'ready',
    MODEL_CHANGED: 'MODEL_CHANGED',
    MODEL_STATE_CHANGED: 'MODEL_STATE_CHANGED',
    CURRENT_EVENT_STATE_CHANGED: 'CURRENT_EVENT_STATE_CHANGED',
    HELPER_STATE_CHANGED: 'HELPER_STATE_CHANGED',
    MENU_STATE_CHANGED: 'MENU_STATE_CHANGED',
    TRANSITION_STATE_CHANGED: 'TRANSITION_STATE_CHANGED'
};
export default CoreEvents;
